import {onFind} from "@elements/init-modules-in-scope";
import {on, hasClass, addClass, removeClass, closest} from "@elements/dom-utils";

export function init() {
    /* open products filter aside */
    onFind('.js-product-aside-toggler', function (button) {
        on('click', function () {
            let body = document.querySelectorAll('body')[0];
            let productnav = document.querySelectorAll('.js-product-aside')[0];
            let stickyBtn = document.querySelectorAll('.js-product-aside-sticky-btn')[0];

            if (hasClass('open', productnav)) {
                removeClass('open', productnav);
                removeClass('open', stickyBtn);
                removeClass('overflow-hidden', body);
            } else {
                addClass('open', productnav);
                addClass('open', stickyBtn);
                addClass('overflow-hidden', body);
            }
        }, button);
    });
}